import { getSessionId } from '../utils/TrackingService';
import type { BaseTrackEvent, TrackEventWithoutIds } from './trackingTypes';

export class TrackingEvent<T extends BaseTrackEvent> {
    timestamp: number;

    sessionId: string;

    constructor(
        public category: string,
        public name: string,
        public source?: string,
        public payload: Record<string, any> = {},
    ) {
        this.category = category;
        this.name = name;
        this.source = source;
        this.payload = payload || ({} as TrackEventWithoutIds<T>);
        this.timestamp = Date.now();
        this.sessionId = getSessionId();
    }

    static copy<T extends BaseTrackEvent, V extends BaseTrackEvent = T>(
        trackingEvent: TrackingEvent<T>,
        payload?: TrackEventWithoutIds<V>,
    ): TrackingEvent<V> {
        const copy = new TrackingEvent(
            trackingEvent.category,
            trackingEvent.name,
            trackingEvent.source,
            payload ?? trackingEvent.payload,
        );

        copy.timestamp = trackingEvent.timestamp;
        copy.sessionId = trackingEvent.sessionId;

        return copy;
    }
}
